import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f8ecd220"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex align-center justify-space-between" }
const _hoisted_2 = { class: "fs-0 show-highest" }

import { Insight, InsightType } from '@/models/insight';
import { computed, PropType } from 'vue';
import { TechnicalScreeningClasses } from "@/models/slide";
import { useStore } from 'vuex';
import { EventBus } from "@/eventBus";
import { useI18n } from "vue-i18n";
import IbIcons from "@/components/icons/ib-icons.vue";
import IBTooltip from '@/components/tooltip/IBTooltip.vue';
import Scalar from './Scalar.vue'
import Likelihood from './Likelihood.vue'
import Threshold from './Threshold.vue'
import Versus from './Versus.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'AiFinding',
  props: {
  insight: {
    type: Object as PropType<Insight>,
    required: true,
  },
},
  emits: ["copyAIFindings"],
  setup(__props, { emit }) {

const props = __props;

const store = useStore()





const poi = computed(() => {
  const pois = store.getters.SLIDE_POIS
  return pois.filter((poi: {"POI Type": string}) => poi["POI Type"] === `screening_${props.insight.key}`)[0];
})

const showHighestScoreLocation = () => {
  EventBus.emit("event-bridge-api", {
    eventName: "set-zoom-and-location-from-vue",
    data: { zoom: 10, x: poi.value["X Coordinate"], y: poi.value["Y Coordinate"] },
  });
}

const aiFindingComponent = computed(() => {
  switch (props.insight.type) {
    case InsightType.SCALAR:
      return Scalar
    case InsightType.RANGE:
      return props.insight.isVs ? Versus : Likelihood
    case InsightType.THRESHOLDED:
      return Threshold
  }
})

const { t } = useI18n({
  inheritLocale: true,
  useScope: "local",
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(IBTooltip, null, {
        default: _withCtx(() => [
          (_unref(poi))
            ? (_openBlock(), _createBlock(IbIcons, {
                key: 0,
                onClick: showHighestScoreLocation,
                icon: "target",
                title: _unref(t)('insights.zoom-to-highest-score'),
                size: 16,
                class: "poi"
              }, null, 8, ["title"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    (__props.insight.is_ai_finding)
      ? (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(aiFindingComponent)), {
          key: 0,
          onCopyAIFindings: _cache[0] || (_cache[0] = ($event: any) => (emit('copyAIFindings'))),
          insight: __props.insight,
          class: "flex-grow ai-finding-component"
        }, null, 40, ["insight"]))
      : _createCommentVNode("", true)
  ]))
}
}

})